import React from "react";
import { useQuery } from "@tanstack/react-query";
import useProductName from "brand-customization/useProductName";
import { SystemPlugins } from "@graylog/server-api";
import { parseVersion, getFullVersion } from "util/Version";
const CloudFooter = () => {
  const { data } = useQuery({
    queryKey: ["system", "plugins"],
    queryFn: () => SystemPlugins.list()
  });
  const plugins = data == null ? void 0 : data.plugins;
  const productName = useProductName();
  let effectiveVersion = getFullVersion();
  const getCloudFooter = (version) => /* @__PURE__ */ React.createElement(React.Fragment, null, productName, " Cloud ", version);
  if (!plugins) {
    return getCloudFooter(effectiveVersion);
  }
  const cloudPlugin = plugins.filter(
    (plugin) => plugin.unique_id === "org.graylog.plugins.cloud.GraylogCloudPlugin"
  )[0];
  if (cloudPlugin == null ? void 0 : cloudPlugin.version) {
    const cloudVersion = parseVersion(cloudPlugin.version);
    if (cloudVersion) {
      const { major, minor, patch, buildMetadata } = cloudVersion;
      effectiveVersion = `${major}.${minor}.${patch} ${buildMetadata ? `(${buildMetadata})` : ""}`;
    }
  }
  return getCloudFooter(effectiveVersion);
};
export default CloudFooter;
